export const ENGINE_API = import.meta.env.VITE_NOTIFICATION_ENGINE_API;
export const ACCESS_KEY = import.meta.env.VITE_NOTIFICATION_ENGINE_API_KEY;
